export class Country {
  public id?: string;
  public name: string;
}
